import {takeEvery} from 'redux-saga';

import {$index, $delete, $post, $put} from '../_utils/restSaga';

import {
  FETCH_GROOMERS_FOR_SKIRESORT,
  DELETE_GROOMER,
  MODIFY_GROOMER,
  ADD_GROOMER,
  fetchGroomersForSkiresortSuccess,
  fetchGroomersForSkiresortFailure,
  deleteGroomerSuccess,
  deleteGroomerFailure,
  modifyGroomerSuccess,
  modifyGroomerFailure,
  addGroomerSuccess,
  addGroomerFailure
} from './actions';

export default function*() {
  yield [
    takeEvery(FETCH_GROOMERS_FOR_SKIRESORT.do, $index('/api/skiresort/#{parent}/groomer',
      fetchGroomersForSkiresortSuccess, fetchGroomersForSkiresortFailure)),
    takeEvery(DELETE_GROOMER.do, $delete('/api/groomer/#{id}',
      deleteGroomerSuccess, deleteGroomerFailure)),
    takeEvery(MODIFY_GROOMER.do, $put('/api/groomer/#{id}',
      modifyGroomerSuccess, modifyGroomerFailure)),
    takeEvery(ADD_GROOMER.do, $post('/api/groomer',
      addGroomerSuccess, addGroomerFailure))
  ];
}



// WEBPACK FOOTER //
// ./src/redux/groomers/saga.js